/* ManTire Atelier — product page */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (c) => (window.ManTire ? window.ManTire.formatMoney(c) : (c / 100).toFixed(0));

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-gallery-track]', this);
      this.items = $$('.gallery__item', this);
      this.thumbs = $$('[data-thumb]', this);
      this.dots = $$('.gallery__dot', this);
      this.counter = $('[data-gallery-current]', this);
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.i = 0;
      this.track.addEventListener('scroll', () => { if (!this.desktop.matches) requestAnimationFrame(() => this.syncScroll()); }, { passive: true });
      this.addEventListener('click', (e) => {
        const t = e.target.closest('[data-thumb]');
        if (t) { this.go(Number(t.dataset.thumb)); return; }
        if (e.target.closest('[data-gallery-prev]')) { this.go(this.i - 1); return; }
        if (e.target.closest('[data-gallery-next]')) { this.go(this.i + 1); return; }
        const z = e.target.closest('[data-zoom]');
        if (!z) return;
        const lb = $('product-lightbox', this.closest('product-page'));
        lb && lb.open(Number(z.dataset.zoom), z);
      });
      this.thumbs.forEach((t) => t.addEventListener('mouseenter', () => this.warm(Number(t.dataset.thumb))));
      this.addEventListener('keydown', (e) => {
        if (!this.desktop.matches || !this.contains(document.activeElement)) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.i + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.i - 1); }
      });
      // hover loupe on the active image (desktop, fine pointers only)
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        this.addEventListener('pointermove', (e) => {
          const z = e.target.closest('.gallery__zoom');
          if (!z || !this.desktop.matches) return;
          const r = z.getBoundingClientRect();
          const img = z.querySelector('img'); if (!img) return;
          img.style.setProperty('--ox', `${((e.clientX - r.left) / r.width) * 100}%`);
          img.style.setProperty('--oy', `${((e.clientY - r.top) / r.height) * 100}%`);
          if (!z.classList.contains('is-loupe')) { clearTimeout(this._loupe); this._loupe = setTimeout(() => z.classList.add('is-loupe'), 120); }
        });
        this.addEventListener('pointerout', (e) => {
          const z = e.target.closest('.gallery__zoom');
          if (z && !z.contains(e.relatedTarget)) { clearTimeout(this._loupe); z.classList.remove('is-loupe'); }
        });
      }
      // load the rest of the images once the page has settled so switching is instant
      const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 1200));
      window.addEventListener('load', () => idle(() => this.items.forEach((_, j) => this.warm(j))), { once: true });
    }
    warm(j) { const img = this.items[j] && this.items[j].querySelector('img'); if (img && img.loading === 'lazy') img.loading = 'eager'; }
    go(n) {
      const len = this.items.length; if (!len) return;
      const i = (n + len) % len;
      if (!this.desktop.matches) { const item = this.items[i]; this.track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' }); return; }
      this.warm(i);
      this.setActive(i);
      const t = this.thumbs[i]; if (t) t.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
    setActive(i) {
      this.i = i;
      this.items.forEach((x, j) => x.classList.toggle('is-active', j === i));
      this.thumbs.forEach((t, j) => { t.classList.toggle('is-active', j === i); if (j === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      this.dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
      if (this.counter) this.counter.textContent = i + 1;
    }
    syncScroll() {
      const w = this.track.clientWidth || 1;
      const i = Math.round(this.track.scrollLeft / w);
      if (i !== this.i) this.setActive(Math.max(0, Math.min(this.items.length - 1, i)));
    }
    show(mediaId) {
      const item = $(`[data-media-id="${mediaId}"]`, this);
      if (!item) return;
      this.go(this.items.indexOf(item));
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductLightbox extends HTMLElement {
    connectedCallback() {
      this.slides = $$('[data-lb-slide]', this);
      this.i = 0;
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-lb-close]')) return this.close();
        if (e.target.closest('[data-lb-prev]')) return this.go(this.i - 1);
        if (e.target.closest('[data-lb-next]')) return this.go(this.i + 1);
        const slide = e.target.closest('[data-lb-slide]');
        if (slide && !this.dragged) this.toggleZoom(slide, e);
      });
      this.addEventListener('pointermove', (e) => {
        const slide = this.slides[this.i];
        if (!slide || !slide.classList.contains('is-zoomed') || e.pointerType === 'touch') return;
        const r = slide.getBoundingClientRect();
        slide.querySelector('img').style.setProperty('--ox', `${((e.clientX - r.left) / r.width) * 100}%`);
        slide.querySelector('img').style.setProperty('--oy', `${((e.clientY - r.top) / r.height) * 100}%`);
      });
      let sx = 0; let sy = 0;
      this.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; this.dragged = false; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - sx; const dy = e.changedTouches[0].clientY - sy;
        const slide = this.slides[this.i];
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) && !(slide && slide.classList.contains('is-zoomed'))) { this.dragged = true; this.go(this.i + (dx < 0 ? 1 : -1)); }
      });
      this.onKey = (e) => {
        if (e.key === 'Escape') this.close();
        if (e.key === 'ArrowRight') this.go(this.i + 1);
        if (e.key === 'ArrowLeft') this.go(this.i - 1);
      };
    }
    open(i, opener) {
      this.opener = opener;
      this.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKey);
      this.go(i);
      const close = $('[data-lb-close]', this); close && close.focus();
    }
    close() {
      this.hidden = true;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this.onKey);
      this.slides.forEach((s) => s.classList.remove('is-zoomed'));
      this.opener && this.opener.focus();
    }
    go(n) {
      const len = this.slides.length; if (!len) return;
      this.i = (n + len) % len;
      this.slides.forEach((s, j) => {
        s.classList.toggle('is-active', j === this.i);
        s.classList.remove('is-zoomed');
        const img = s.querySelector('img');
        if (Math.abs(j - this.i) <= 1 && !img.src) img.src = img.dataset.src;
      });
      const c = $('[data-lb-current]', this); if (c) c.textContent = this.i + 1;
    }
    toggleZoom(slide, e) {
      const img = slide.querySelector('img');
      const r = slide.getBoundingClientRect();
      img.style.setProperty('--ox', `${((e.clientX - r.left) / r.width) * 100}%`);
      img.style.setProperty('--oy', `${((e.clientY - r.top) / r.height) * 100}%`);
      slide.classList.toggle('is-zoomed');
    }
  }
  customElements.define('product-lightbox', ProductLightbox);

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      try { this.variants = JSON.parse($('[data-variants]', this).textContent); } catch { this.variants = []; }
      this.page = this.closest('product-page');
      this.addEventListener('change', () => this.update());
      this.markAvailability();
    }
    selected() { return $$('input[type="radio"]:checked', this).map((i) => i.value); }
    markAvailability() {
      const sel = this.selected();
      $$('input[type="radio"]', this).forEach((input) => {
        const idx = Number(input.dataset.optionIndex);
        const opts = sel.slice(); opts[idx] = input.value;
        const v = this.variants.find((x) => x.options.every((o, k) => o === opts[k]));
        input.classList.toggle('is-unavailable', !v || !v.available);
      });
    }
    update() {
      const sel = this.selected();
      sel.forEach((v, i) => { const lab = $(`[data-option-value="${i}"]`, this); if (lab) lab.textContent = v; });
      const v = this.variants.find((x) => x.options.every((o, k) => o === sel[k]));
      this.markAvailability();
      const p = this.page;
      const add = $('[data-add]', p); const label = $('[data-add-label]', p); const sticky = $('[data-sticky-add]', p); const buyNow = $('[data-buy-now]', p);
      if (buyNow) buyNow.disabled = !(v && v.available);
      if (!v) { if (add) add.disabled = true; if (label) label.textContent = p.dataset.unavailable || 'Unavailable'; return; }
      $$('[data-variant-id]', p).forEach((i) => (i.value = v.id));
      // Fabric details card: the chosen length and its SKU
      $$('[data-spec-length]', p).forEach((dd) => { const val = sel[Number(dd.dataset.specLength)]; if (val) dd.textContent = val.replace(/\bmet(er|re)\b/i, (m) => m[0].toUpperCase() + m.slice(1)); });
      const sku = $('[data-spec-sku]', p); if (sku && v.sku) sku.textContent = v.sku;
      if (add) add.disabled = !v.available;
      if (sticky) sticky.disabled = !v.available;
      if (label) label.textContent = v.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
      const addPrice = $('[data-add-price]', p); if (addPrice) addPrice.textContent = money(v.price);
      const stickyPrice = $('[data-sticky-price]', p); if (stickyPrice) stickyPrice.textContent = money(v.price);
      const priceWrap = $('[data-price-wrap] [data-price]', p);
      if (priceWrap) {
        const cur = $('.price__current', priceWrap); if (cur) cur.textContent = money(v.price);
        let cmp = $('.price__compare', priceWrap); let save = $('.price__save', priceWrap);
        if (v.compare > v.price) {
          if (!cmp) { cmp = document.createElement('s'); cmp.className = 'price__compare'; priceWrap.appendChild(cmp); }
          if (!save) { save = document.createElement('span'); save.className = 'price__save'; priceWrap.appendChild(save); }
          cmp.textContent = money(v.compare);
          save.textContent = save.textContent.replace(/\d+%/, `${Math.floor(((v.compare - v.price) * 100) / v.compare)}%`);
          cmp.hidden = false; save.hidden = false;
        } else { if (cmp) cmp.hidden = true; if (save) save.hidden = true; }
      }
      const prepaid = $('[data-prepaid]', p);
      if (prepaid) {
        const tiers = prepaid.dataset.tiers.split(',').map((t) => t.split(':').map(Number)).filter((t) => t.length === 2);
        let pct = 0;
        tiers.forEach(([from, pc]) => { if (v.price >= from * 100) pct = pc; });
        const text = $('[data-prepaid-text]', prepaid);
        if (text) {
          if (pct > 0) {
            const pay = Math.ceil((v.price - Math.floor((v.price * pct) / 100)) / 100) * 100;
            text.innerHTML = prepaid.dataset.lead.replace('[amount]', money(pay)).replace('[pct]', pct);
          } else if (tiers.length) {
            text.innerHTML = prepaid.dataset.unlock.replace('[amount]', money(tiers[0][0] * 100 - v.price)).replace('[pct]', tiers[0][1]);
          }
        }
        $$('.poffer', prepaid).forEach((li) => {
          const on = pct > 0 && Number(li.dataset.pct) === pct;
          li.classList.toggle('is-active', on);
          const tag = $('.poffer__tag', li); if (tag) tag.textContent = on ? tag.dataset.active : tag.dataset.store;
        });
      }
      if (v.media) { const g = $('product-gallery', p); g && g.show(v.media); }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }
  }
  customElements.define('variant-picker', VariantPicker);

  class StickyBuy extends HTMLElement {
    connectedCallback() {
      const buy = $('[data-buy]', this.closest('product-page'));
      if (!buy) return;
      this.hidden = false;
      const footer = $('.footer');
      let ticking = false;
      const sync = () => {
        ticking = false;
        const pastBuy = buy.getBoundingClientRect().bottom < 0;
        const atFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        this.classList.toggle('is-visible', pastBuy && !atFooter);
      };
      window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(sync); } }, { passive: true });
      sync();
    }
  }
  customElements.define('sticky-buy', StickyBuy);

  class ProductPage extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', async (e) => {
        const copy = e.target.closest('[data-copy-link]');
        if (!copy) return;
        try { await navigator.clipboard.writeText(copy.dataset.copyLink); } catch {}
        window.ManTire && window.ManTire.toast(copy.dataset.copied);
      });
    }
  }
  customElements.define('product-page', ProductPage);

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url) return;
      const load = async () => {
        try {
          const html = await (await fetch(this.dataset.url)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector(`product-recommendations[data-intent="${this.dataset.intent}"]`);
          // Luxury product pages offer luxury-priced fabrics only.
          const t = window.theme || {};
          // Luxury look: luxury-priced fabrics only. Fabric Mall look: fabrics up to the Mall cap.
          const lux = document.documentElement.dataset.mode === 'luxury';
          if (fresh && t.luxuryFrom && t.mallMax) fresh.querySelectorAll('[data-rec-item]').forEach((li) => { const c = li.querySelector('[data-price]'); const pr = c && Number(c.dataset.price); if (c && (lux ? pr < t.luxuryFrom : pr > t.mallMax)) li.remove(); });
          if (fresh && fresh.querySelector('[data-rec-item]')) {
            const track = this.querySelector('[data-track]');
            const freshTrack = fresh.querySelector('[data-track]');
            if (track && freshTrack) track.innerHTML = freshTrack.innerHTML; else this.innerHTML = fresh.innerHTML;
            this.hidden = false;
            const c = this.querySelector('carousel-slider'); c && c.update && c.update();
          } else if (!this.querySelector('[data-rec-item]')) { this.closest('.shopify-section').hidden = true; }
        } catch {}
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(([en]) => { if (en.isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 600px 0px' });
        io.observe(this);
      } else load();
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  // Available colours: the other colours of this fabric as photo cards. Colour groups come from the Bob bundle builder (its
  // block on the page); for a fabric Bob has no group for, the row finds the colours by the fabric's name instead.
  const COLOUR_TITLE = /^(.*?)\s+colou?r\s+(.+)$/i;
  class ColourSiblings extends HTMLElement {
    connectedCallback() {
      const data = window.CROWD_BUY_LINKED_PRODUCTS;
      const groups = (data && data.optionGroups) || [];
      const group = groups.find((g) => g && g.behavior === 'switch' && Array.isArray(g.products) && g.products.length > 1);
      // Anything beyond colour switching (bundles, add-ons) is left to Bob's own widget, which then shows instead.
      if (groups.length && (!group || groups.some((g) => !g || g.behavior !== 'switch'))) { document.documentElement.classList.add('bob-widget'); return; }
      if (group) { this.render(group.products.filter((p) => p && p.handle), group.label); return; }
      this.findByName();
    }
    // No colour group in Bob: search for the fabric's name (the title before "Colour") and keep exact matches. Search returns published fabrics only.
    async findByName() {
      const m = COLOUR_TITLE.exec(this.dataset.title || '');
      if (!m || !window.fetch) return;
      const name = m[1].trim().toLowerCase();
      try {
        const base = (window.theme && window.theme.routes && window.theme.routes.search) || '/search';
        const html = await (await fetch(`${base}?q=${encodeURIComponent(m[1].trim())}&type=product&section_id=colour-search`)).text();
        const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-colour-results]');
        const found = el ? JSON.parse(el.textContent) : [];
        const items = []; const seen = new Set();
        found.forEach((p) => {
          const mm = COLOUR_TITLE.exec((p && p.title) || '');
          if (!mm || mm[1].trim().toLowerCase() !== name || seen.has(p.handle)) return;
          seen.add(p.handle); items.push({ handle: p.handle, title: p.title, image: p.image, optionLabel: mm[2].trim() });
        });
        if (!seen.has(this.dataset.handle)) items.unshift({ handle: this.dataset.handle, title: this.dataset.title, image: this.dataset.image, optionLabel: m[2].trim() });
        if (items.length > 1) this.render(items, null);
      } catch (e) { /* no colour row */ }
    }
    render(items, groupLabel) {
      const here = this.dataset.handle;
      const current = items.find((p) => p.handle === here);
      const label = (current && current.optionLabel) || this.dataset.label || '';
      const esc = (t) => String(t == null ? '' : t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const sized = (src) => { try { const u = new URL(src, location.origin); u.searchParams.set('width', '240'); return u.toString(); } catch { return src; } };
      const cards = items.map((p) => {
        const on = p.handle === here;
        return `<li><a class="colour-card${on ? ' is-current' : ''}" href="/products/${encodeURIComponent(p.handle)}"${on ? ' aria-current="true"' : ''}>`
          + `<span class="colour-card__img">${p.image ? `<img src="${esc(sized(p.image))}" alt="${esc(p.title || p.optionLabel)}" width="240" height="240" loading="lazy" decoding="async">` : ''}</span>`
          + `<span class="colour-card__name">${esc(p.optionLabel || p.title)}</span></a></li>`;
      }).join('');
      this.innerHTML = `<p class="colours__head">${esc(this.dataset.heading || groupLabel || 'Available colours')}: <b>${esc(label)}</b></p>`
        + `<scroll-row class="scroll-row"><ul class="colours__list" role="list" data-scroll-track>${cards}</ul></scroll-row>`;
      this.hidden = false;
      document.documentElement.classList.add('has-colours');
      // Colours that turn out not to be published (Bob's list can include them) are dropped as their checks come back.
      const status = window.__productStatus || {};
      const prune = () => {
        this.querySelectorAll('.colour-card:not(.is-current)').forEach((a) => {
          const h = decodeURIComponent(a.getAttribute('href').split('/products/')[1] || '');
          if (status[h] && status[h] >= 400) a.closest('li').remove();
        });
        if (this.querySelectorAll('.colour-card').length < 2) { this.hidden = true; document.documentElement.classList.remove('has-colours'); return; }
        this.centre();
      };
      prune();
      document.addEventListener('product:status', prune);
    }
    centre() {
      // Scroll the row (never the page) so the current colour sits in the middle
      const track = this.querySelector('[data-scroll-track]'); const cur = this.querySelector('.is-current');
      if (!track || !cur) return;
      const li = cur.closest('li');
      track.scrollLeft = Math.max(0, li.offsetLeft - (track.clientWidth - li.offsetWidth) / 2);
    }
  }
  customElements.define('colour-siblings', ColourSiblings);
})();
